export default {"src":"/_next/static/media/TSLY.6886ff44.svg","height":18,"width":18};